// extracted by mini-css-extract-plugin
module.exports = {"shiftBody":"App_shiftBody__sMG18","nochange":"App_nochange__2agWQ"};